import { dayNumber } from '@mp/core';

/** Player's local calendar day as 'YYYY-MM-DD' (daily gift, streak, daily puzzle are local-day based). */
export function localDayKey(ms: number): string {
  const d = new Date(ms);
  const p = (n: number) => n.toString().padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function localDay(ms: number): number {
  return dayNumber(localDayKey(ms));
}
